module.exports = __webpack_public_path__ + "img/logo-round.b3ff2f58.svg";